import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ breakpoints }) => ({
  root: {
    width: "100%",

    [breakpoints.down("sm")]: {
      flexDirection: "column"
    },
    [breakpoints.up("sm")]: {
      width: "100%",
      minWidth: "560px"
    },
    [breakpoints.up("md")]: {
      width: "100%",
      maxWidth: "800px"
    },
    [breakpoints.up("lg")]: {
      maxWidth: "900px"
    }
  },
  static: {
    minWidth: "100%"
  }
}))
